export enum SettingsTabs {
  PROFILE = 'My Profile & Cards',
  ROOM_REACTIONS = 'Room Reactions',
  EMOTES = 'Emotes',
}

export const tabs = Object.values(SettingsTabs);
